import { ReactNode } from 'react';
import { Target } from '@mews/enums';
import { OptimusPlainLink, OptimusPlainLinkProps } from './PlainLink';

interface NewTabLinkProps extends Omit<OptimusPlainLinkProps, 'onClick'> {
    url: string;
    children: ReactNode;
    inherit?: boolean;
}

export const NewTabLink = ({ children, url, inherit = true, ...other }: NewTabLinkProps) => (
    <OptimusPlainLink
        href={url}
        onClick={() => {
            window.open(url);
        }}
        target={Target.Blank}
        inherit={inherit}
        {...other}
    >
        {children}
    </OptimusPlainLink>
);
